import { render, staticRenderFns } from "./DeliverDistancePage.vue?vue&type=template&id=1d949e5e&"
import script from "./DeliverDistancePage.vue?vue&type=script&lang=js&"
export * from "./DeliverDistancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports